import(/* webpackMode: "eager", webpackExports: ["SidebarContainer"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/_common/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TVLChart"] */ "/vercel/path0/apps/web/src/ui/explore/tvl-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VolumeChart"] */ "/vercel/path0/apps/web/src/ui/explore/volume-chart.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/pathname-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/pool/PoolPositionProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/pool/PoolsFiltersProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/pool/Rate.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/pool/RewardsSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/ui/pool/UnknownTokenAlert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkInternal"] */ "/vercel/path0/packages/ui/dist/components/link.js");
